import axios from 'axios'
import { getUserToken } from './functions.js'
import {getServerApi} from './config/deployment'

let envUri = getServerApi()
var uri =envUri+"/api/distribution/channels/excluded"

export const updateExcludedChannels = (listingId, channels) => {
  return getUserToken()
    .then(res => {
      var data = {
        token: res,
        maaklerID: listingId,
        channels: channels
      }
      return axios.post(uri, data)
        .then(res => {
          if(res.data.code == 200) return res.data.body
          return false
        })
        .catch(err => {
          return false
        })
    })
}



// WEBPACK FOOTER //
// ./src/channelRepository.js